module.exports = __webpack_public_path__ + "static/media/proj_4.361d2700.png";